module.exports = __webpack_public_path__ + "6a3e029f65306c0f43e3b1bc0a1b3ddd.glb";